

































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Button, FormItem, Input, Select, Option } from 'element-ui';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import { i18n } from '@/plugins/i18n';
// Types
import {
  fetchQuotes_inquiries_quotes_inquiry,
  CargoDescriptionInput,
  RequestedContainerInput
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
// Contants
import { containerSizes } from '@/constants/containerSize';

@Component({
  components: {
    CollapseCard,
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option
  }
})
export default class Container extends Vue {
  @Prop({ required: true }) private inquiry!: fetchQuotes_inquiries_quotes_inquiry;

  private containerInput: CargoDescriptionInput = {
    containers: [{
      contentNetWeight: null,
      requestedContainerCount: null,
      requestedContainerType: null
    }]
  };

  private emptyContainer: RequestedContainerInput = {
    contentNetWeight: null,
    requestedContainerCount: null,
    requestedContainerType: null
  };

  private addContainer() {
    this.$set(
      this.containerInput.containers!,
      this.containerInput.containers!.length || 0,
      { ...this.emptyContainer }
    );
  }

  public containerOptions(): SelectOption<string>[] {
    return containerSizes.map((size) => {
      return { ...size, label: this.$t(`container.sizes.${size.value}`) as string };
    });
  }

  private removeContainer(index: number) {
    this.$delete(this.containerInput.containers!, index);
  }

  get totalWeight() {
    let total = 0;
    if (this.containerInput.containers) {
      for (const container of this.containerInput!.containers!) {
        total += container.contentNetWeight || 0;
      }
    }
    return total;
  }

  @Watch('inquiry.cargoDescription.containers', { immediate: true })
  private setInputs(containers: RequestedContainerInput[]) {
    this.containerInput.containers = (containers || []).map((container: any) => {
      return {
        contentNetWeight: container.contentNetWeight || null,
        requestedContainerCount: container.requestedContainerCount || null,
        requestedContainerType: container.requestedContainerType || null
      };
    });
  }

  @Watch('containerInput.containers', { deep: true })
  private emitInputs(containerInput: CargoDescriptionInput) {
    this.$emit('update', containerInput);
  }
}
